import { Reveal } from "./Reveal";
import { CHAPTERS } from "../../data/site";

export const Manifesto = () => (
  <section id="how" data-testid="manifesto-section" className="py-28 md:py-36 bg-[#1A362D] text-[#F9F8F6] relative overflow-hidden grain">
    <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
      <Reveal>
        <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#C26D5C] mb-6">How it works</p>
        <h2 className="font-serif font-light text-5xl md:text-6xl tracking-tight max-w-2xl leading-[1.05]">
          Dependable help, arranged in four calm steps.
        </h2>
      </Reveal>

      <div className="mt-20 divide-y divide-[#4A5A53]/40 border-t border-[#4A5A53]/40">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05}>
            <div className="relative grid md:grid-cols-12 gap-6 py-12 items-baseline group">
              <span className="md:col-span-3 font-serif text-7xl md:text-8xl text-[#F9F8F6]/10 group-hover:text-[#C26D5C]/40 transition-colors duration-500 leading-none">
                {c.n}
              </span>
              <h3 className="md:col-span-4 font-serif text-3xl md:text-4xl text-[#F9F8F6]">{c.title}</h3>
              <p className="md:col-span-5 text-[#D1DEC9] leading-relaxed text-lg">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
